import {monthList} from './MonthList.js';
import {locations} from './AgereBranches.js';

class GetSingleCourse {
  constructor() {
    this.outputElement = document.querySelector('#nextCourses');
    this.months = monthList;
    this.locations = locations;
    this.courseCode = document.querySelector('#forerkortklasse');
    this.className;
    if (this.courseCode) {
      this.className = this.courseCode.value;
    }
    this.relevantLocations = this.getRelevantLocations();
    this.availableClasses = this.getAvailableClasses();
    this.availableCourses = [];
    this.output = "";
    this.printCourses = [];
    this.init();
  }

  init() {
    this.output = '<ul class="nextCourse">';
    if (this.availableClasses.includes(this.className)) {
      this.relevantLocations.forEach(location => {
        fetch(`https://api.tabs.no/api/v1/courses?officeId=${location.id}`).then(res => res.text()).then(res => {
          res = JSON.parse(res);
          let needle = res.drivingClasses.find(el => el.short_name === this.className)

          if (!this.availableCourses.includes(needle)) {
            this.availableCourses.push(needle);
            return needle;
          }
        }).then(courses => {
          if (courses) {
            courses.courseEvents.forEach(singleCourse => {
              const start = new Date(singleCourse.courseEvent.startTime);
              const end = new Date(singleCourse.courseEvent.endTime);
              const date = start.getDate() + '. ' + this.months[start.getMonth()] + ' ' + start.getFullYear() % 100;
              const time = start.getHours() + '' + (start.getMinutes() < 10 ? '0' : '') + start.getMinutes() + '-' + end.getHours() + '' + (end.getMinutes() < 10 ? '0' : '') + end.getMinutes()
              singleCourse.courseEvent['date'] = date;
              singleCourse.courseEvent['time'] = time;

              this.output += `
              <li><a href="${location.url}">${singleCourse.courseEvent.courseName} ${singleCourse.courseEvent.date}<span class="table-arrow"><div></div><div></div></span></a></li>`;
            });
          }
        })
    });


  }

  setTimeout(() => {
    if (this.availableCourses.length == 0 || !this.availableCourses[0]) {
      this.output = "<ul><li>Ingen kurs i nærmeste fremtid!</li></ul>";
    } else {
      this.output += "</ul>";
    }
    if (this.outputElement) {
      this.outputElement.insertAdjacentHTML('beforeend', this.output);
    }
    }, 750)
  }

  getRelevantLocations() {
    let relevantLocations = [];
    this.locations.forEach(location => {
      location.classes.forEach(classType => {
        if (classType == this.className) {
          relevantLocations.push(location);
        }
      })
    })
    return relevantLocations;
  }

  getAvailableClasses() {
    let classes = [];
    this.locations.forEach(location => {
      location.classes.forEach(classType => {
        classes.push(classType)
      })
    })
    return classes;
  }
}

export default GetSingleCourse;